export enum APITypeEnum {
  GET_ALL = 'getAll',
  GET_ONE = 'getOne',
  POST_NEW = 'postNew',
  PUT = 'put',
  DELETE = 'delete',
  DELETE_ALL = 'deleteAll',
  STATUS_ALL = 'statusAll',
  METHOD_DELETE = 'MethodDelete'
}

export type APIType =
  | APITypeEnum.GET_ALL
  | APITypeEnum.GET_ONE
  | APITypeEnum.POST_NEW
  | APITypeEnum.PUT
  | APITypeEnum.DELETE
  | APITypeEnum.DELETE_ALL
  | APITypeEnum.STATUS_ALL
  | APITypeEnum.METHOD_DELETE;
